module.exports = () => ({
  ok: true,
  status: 200,
  json: () => Promise.resolve({ location_id: 'something new' }),
})
